import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { IMaskInput } from "react-imask";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value?: string;
  maxLength?: number;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={Number}
        scale={0}
        thousandsSeparator=""
        padFractionalZeros={true}
        normalizeZeros={true}
        radix="."
        value={props.value || ""}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
        unmask={false}
      />
    );
  }
);

export default function CustomIntNumberTextField({ ...props }) {
  const {
    label,
    name,
    defaultValue,
    onChange,
    onBlur,
    helperText,
    required,
    small,
  } = props;

  const [error, setError] = React.useState(props?.error || false);
  const [customErrorText, setCustomErrorText] = React.useState("");
  const [value, setValue] = React.useState(defaultValue?.toString() || "");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);

    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          name,
          value: newValue,
        },
      });
    }
  };

  const handleBlur = () => {
    if (required && !value) {
      setError(true);
    } else {
      if (props?.maxNum || props?.minNum) {
        const numValue = parseInt(value);

        if (props.maxNum !== undefined && numValue > props.maxNum) {
          setCustomErrorText(
            `Value must be less than or equal to ${props.maxNum}`
          );
          setError(true);
        } else if (props.minNum !== undefined && numValue < props.minNum) {
          setCustomErrorText(
            `Value must be greater than or equal to ${props.minNum}`
          );
          setError(true);
        } else {
          setCustomErrorText("");
          setError(false);
        }
      } else {
        setError(false);
      }
    }

    if (onBlur) {
      onBlur();
    }
  };

  let helperTextValue = error
    ? helperText?.toString() || "This field is required"
    : "";

  if (customErrorText != "" && error) {
    helperTextValue = customErrorText;
  }

  return (
    <Stack direction="row" spacing={2}>
      <FormControl variant="standard" error={error}>
        {label && (
          <InputLabel htmlFor={`formatted-text-mask-input-${name}`}>
            {label}
          </InputLabel>
        )}
        <OutlinedInput
          sx={{
            "& input": {
              // padding: "8.5px 14px"
              padding: "12px 14px",
            },
            width: small ? "100px" : "100%",
          }}
          id={`formatted-text-mask-input-${name}`}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          inputComponent={TextMaskCustom as any}
          inputProps={{
            name: name,
            id: name,
            onChange: handleChange,
          }}
          className="numericText"
        />
        {error && helperTextValue && (
          <FormHelperText sx={{ color: "#d32f2f", marginLeft: "14px" }}>
            {helperTextValue}
          </FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
}
